import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { BusinessSaleService } from 'src/app/services/business-sale.service';
import { CakeSaleService } from 'src/app/services/cake-sale.service';
import { DeliveryService } from 'src/app/services/delivery.service';
import { FlowersSaleService } from 'src/app/services/flowers-sale.service';
import { PartnerSaleActivityService } from 'src/app/services/partner-sale-activity.service';
import { ShopifySaleService } from 'src/app/services/shopify-sale.service';
import { SaleInfoComponent } from '../sale-info/sale-info.component';
import { MatDialog } from '@angular/material/dialog';
import { PartnerService } from 'src/app/services/partner.service';
import { MapHelperService } from 'src/app/helpers/maps-service-helpher.service';
import { Delivery } from 'src/app/models/delivery.schema';
import { DeluxyExperienceSalesService } from 'src/app/services/deluxy-experience-sales.service';
import { DeluxyDotComSalesService } from 'src/app/services/deluxy-dot-com-sales.service';

@Component({
  selector: 'app-partner-sale-activity',
  templateUrl: './partner-sale-activity.component.html',
  styleUrls: ['./partner-sale-activity.component.scss']
})
export class PartnerSaleActivityComponent implements OnInit {
  
  groups: any;
  limit: number;
  page: number;
  count: number = 0;
  maxPage: number;
  order: {};
  defaultPage = 1;
  defaultLimit = 100;
  defaultOrder = { 'PartnerShopifySaleActivity.id': 'DESC' };
  filtered = {};
  partnerShopifySaleActivities: any[] = [];
  activityFilterForm: any;
  selected: string = 'active';
  salesToBeConfirm: any[] = [];
  saleBtn: boolean = false;
  showAddressModal: boolean = false;
  selectedPickupAddress: string | null = null;
  isConfirming: boolean = false;
  partnerPickupAddresses: string[] = [];
  selectedPartner: any = null;
  partnerHasMultipleAddresses: boolean = false;
  pendingSaleAction: {
    type: 'unique' | 'nonUnique',
    deliveryId?: number,
    token?: string,
    deliveryInformation?: Delivery
  } | null = null;

  settings = {
    active: {
      title: "Partner Vendita",
    },
    inactive: {
      title: "Storico Partner Vendita",
    }
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private partnerSaleActivityService: PartnerSaleActivityService,
    private _snackBar: MatSnackBar,
    private deliveryService: DeliveryService,
    private shopifySaleService: ShopifySaleService,
    private cakeSaleService: CakeSaleService,
    private businessSaleService: BusinessSaleService,
    private flowersSaleService: FlowersSaleService,
    private deluxyExperienceSalesService: DeluxyExperienceSalesService,
    private deluxyDotComSalesService: DeluxyDotComSalesService,
    public dialog: MatDialog,
    private partnerService: PartnerService,
    private mapHelperService: MapHelperService,
  ) {
    this.manageSaleActivityFilterForm();
  }

  async ngOnInit() {
    try {
      this.selected = !this.route.snapshot.data['active'] ? 'inactive' : 'active';
      await this.init();
    } catch (error) {
      
    }
  }

  async init(){
    this.selected == 'active' ? 
    await this.fetchVenditaToConfirm() :
    await this.loadPartnerSaleActivities();
  }

  async fetchVenditaToConfirm(){
    try {
      let allSalesToBeConfirm = await this.partnerSaleActivityService.fetchVenditaToConfirm();
      this.salesToBeConfirm = allSalesToBeConfirm.allSaleDelivery;
    } catch (error) {
      console.log("ERROR", error);
    }
  }

  manageSaleActivityFilterForm(){
    this.activityFilterForm = new FormGroup({
      'PartnerShopifySaleActivity.id': new FormControl(''),
      'PartnerShopifySaleActivity.saleId': new FormControl(''),
      'PartnerShopifySaleActivity.orderId': new FormControl(''),
      'PartnerShopifySaleActivity.status': new FormControl(''),
      'PartnerShopifySaleActivity.shop': new FormControl(''),
    });
  }

  async loadPartnerSaleActivities(limit?: number, page?: number, order?: {}){
    this.page = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
    this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
    this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;
    let data = await this.partnerSaleActivityService.getAllPartnerSaleActivities(this.page, this.limit, this.order, this.filtered);
    this.partnerShopifySaleActivities = data;
    this.count = this.partnerShopifySaleActivities.length;
    this.maxPage = Math.ceil(this.count / this.limit);
  }

  async deletePartnerShopifySaleActivity(activityId: number){
    try {
      if (!confirm("Sei sicuro di voler eliminare la tua vendita?")){ return; }
      let deleteResult = await this.partnerSaleActivityService.deletePartnerSaleActivity(activityId);
      if(deleteResult){
        this._snackBar.open('Vendita eliminata con successo', 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        }).afterDismissed().subscribe(result => {
          this.loadPartnerSaleActivities();
        })
      }
    } catch (error) {
      this._snackBar.open('Qualcosa è andato storto', 'Chiudi', {
        direction: "ltr",
        duration: 2000,
        horizontalPosition: "center",
        politeness: "assertive",
        verticalPosition: "top"
      })
    }

  }

  async filter(){
    let filterForm = (new FormGroupToObject()).transform(this.activityFilterForm);
    this.filtered = {};

    if (filterForm['PartnerShopifySaleActivity.id'])
      this.filtered['PartnerShopifySaleActivity.id'] = filterForm['PartnerShopifySaleActivity.id'];    
    if (filterForm['PartnerShopifySaleActivity.saleId'])
      this.filtered['PartnerShopifySaleActivity.saleId'] = filterForm['PartnerShopifySaleActivity.saleId'];
    if (filterForm['PartnerShopifySaleActivity.orderId'])
      this.filtered['PartnerShopifySaleActivity.orderId'] = filterForm['PartnerShopifySaleActivity.orderId'];
    if (filterForm['PartnerShopifySaleActivity.status'])
      this.filtered['PartnerShopifySaleActivity.status'] = { operator: 'like', values: [`%${filterForm['PartnerShopifySaleActivity.status']}%`] };
    if (filterForm['PartnerShopifySaleActivity.shop'])
      this.filtered['PartnerShopifySaleActivity.shop'] = { operator: 'like', values: [`%${filterForm['PartnerShopifySaleActivity.shop']}%`] };

    this.loadPartnerSaleActivities();
  }

  showShopName(sale: any){
    let deliveryInfo = JSON.parse(sale.deliveryInfo);
    return deliveryInfo?.shop?.toUpperCase();
  }

  public async acceptSaleForUniqueProduct(deliveryInfo: any){

    let deliveryInformation: Delivery = JSON.parse(deliveryInfo);

    if(deliveryInformation.partner?.isMultiplePickUpAddress && deliveryInformation.partner?.pickupAddresses?.length > 0) {
      this.selectedPartner = deliveryInformation.partner;
      this.partnerPickupAddresses = deliveryInformation.partner.pickupAddresses;
      this.partnerHasMultipleAddresses = true;

      this.pendingSaleAction = {
        type: 'unique',
        deliveryId: deliveryInformation.id,
        deliveryInformation
      };

      this.showAddressModal = true;
      return;
    } 
    
    if (!confirm("Accetti la nuova consegna?")) return;
    await this.manageSaleForUniqueProduct(deliveryInformation?.id, 'accept');
  }

  public async refuseSaleForUniqueProduct(deliveryInfo: any){
    if (!confirm("Rifiuti la nuova consegna?"))
      return;
    let deliveryInformation = JSON.parse(deliveryInfo);
    await this.manageSaleForUniqueProduct(deliveryInformation?.id, 'refuse');
  }

  async manageSaleForUniqueProduct(deliveryId: number, status: string){
    this.saleBtn = true;
    let promise = this.deliveryService.manageSaleForUniqueProduct(deliveryId, status);
    promise.then(async (res) => {
      this.saleBtn = false;
      await this.init();
    }).catch((err) => {
      this.saleBtn = false;
    })
  }

  async acceptSaleForNonUniqueProduct(token: string, deliveryInfo: any){
    try {

      let deliveryInformation: Delivery = JSON.parse(deliveryInfo);

      if(deliveryInformation.partner?.isMultiplePickUpAddress && deliveryInformation.partner?.pickupAddresses?.length > 0) {
        this.selectedPartner = deliveryInformation.partner;
        this.partnerPickupAddresses = deliveryInformation.partner.pickupAddresses;
        this.partnerHasMultipleAddresses = true;

        this.pendingSaleAction = {
          type: 'nonUnique',
          token,
          deliveryInformation
        };
      
        this.showAddressModal = true;
        return;
      } 
      
      if (!confirm("Confermi di accettare la vendita?")) return;
      await this.processNonUniqueAccept(token, deliveryInformation);

      /*
      if(deliveryInformation?.shop){
        if(deliveryInformation?.shop?.toLowerCase() === 'shopifysale'){
          result = await this.shopifySaleService.acceptSale(token, undefined, deliveryInformation);
        }
        if(deliveryInformation?.shop?.toLowerCase() === 'cakesales'){
          result = await this.cakeSaleService.acceptSale(token, undefined, deliveryInformation);
        }
        if(deliveryInformation?.shop?.toLowerCase() === 'flowerssales'){
          result = await this.flowersSaleService.acceptSale(token, undefined, deliveryInformation);
        }
        if(deliveryInformation?.shop?.toLowerCase() === 'businesssales'){
          result = await this.businessSaleService.acceptSale(token, undefined, deliveryInformation);
        }
      }

      if(result){
        this._snackBar.open('Sale has been accepted', 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        }).afterDismissed().subscribe(async (res) => {
          if(result?.id){
            this.router.navigate(['/consegne', result?.id]).then(() => {
              window.location.reload();
            });
          }
        })
      } else {
        this.showSnackBar('Something went wrong');
      }
      */
    } catch (error) {
      if(error.error.message === 'ALREDAY_ACCEPTED'){
        this.showSnackBar('Sale has been already accepted');
      } else if(error.error.message === 'SALE_SERVICE_NOT_AVAILABLE') {
        this.showSnackBar('Partner has not sale type service. Can not accept sale');
      } else {}
    }
  }

  private async processNonUniqueAccept(token: string, deliveryInformation: Delivery) {
    let result: any;

    try {
      if (deliveryInformation?.shop) {
        const shop = deliveryInformation.shop.toLowerCase();
  
        if (shop === 'shopifysale') {
          result = await this.shopifySaleService.acceptSale(token, undefined, deliveryInformation);
        }
        if (shop === 'cakesales') {
          result = await this.cakeSaleService.acceptSale(token, undefined, deliveryInformation);
        }
        if (shop === 'flowerssales') {
          result = await this.flowersSaleService.acceptSale(token, undefined, deliveryInformation);
        }
        if (shop === 'businesssales') {
          result = await this.businessSaleService.acceptSale(token, undefined, deliveryInformation);
        }
        if (shop === 'deluxyexperience') {
          result = await this.deluxyExperienceSalesService.acceptSale(token, undefined, deliveryInformation);
        }
        if (shop === 'deluxydotcom') {
          result = await this.deluxyDotComSalesService.acceptSale(token, undefined, deliveryInformation);
        }
      }
  
      if (result) {
        this._snackBar.open('Sale has been accepted', 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        }).afterDismissed().subscribe(async (res) => {
          if(result?.id){
            this.router.navigate(['/consegne', result?.id]).then(() => {
              window.location.reload();
            });
          }
        });
        await this.init();
      } else {
        this.showSnackBar('Something went wrong');
      }
    } catch (error) {
      if(error.error.message === 'ALREDAY_ACCEPTED'){
        this.showSnackBar('Sale has been already accepted');
      } else if(error.error.message === 'SALE_SERVICE_NOT_AVAILABLE') {
        this.showSnackBar('Partner has not sale type service. Can not accept sale');
      } else {}
    }
  }

  async refuseSaleForNonUniqueProduct(token: string, deliveryInfo: any){
    try {
      if (!confirm("Confermi di rifiutare la vendita?"))
        return;
      let result: any;
      let deliveryInformation = JSON.parse(deliveryInfo);
      if(deliveryInformation?.shop){
        if(deliveryInformation?.shop?.toLowerCase() === 'shopifysale'){
          result = await this.shopifySaleService.refuseSale(token, undefined);
        }
        if(deliveryInformation?.shop?.toLowerCase() === 'cakesales'){
          result = await this.cakeSaleService.refuseSale(token, undefined);
        }
        if(deliveryInformation?.shop?.toLowerCase() === 'flowerssales'){
          result = await this.flowersSaleService.refuseSale(token, undefined);
        }
        if(deliveryInformation?.shop?.toLowerCase() === 'businesssales'){
          result = await this.businessSaleService.refuseSale(token, undefined);
        }
        if (deliveryInformation?.shop?.toLowerCase() === 'deluxyexperiencesales') {
          result = await this.deluxyExperienceSalesService.refuseSale(token, undefined);
        }
        if (deliveryInformation?.shop?.toLowerCase() === 'deluxydotcomsales') {
          result = await this.deluxyDotComSalesService.refuseSale(token, undefined);
        }
      }
      if(result){
        await this.init();
        this.showSnackBar('Sale has been refused');
      }
    } catch (error) {
      this.showSnackBar('Something went wrong');
    }
  }
  
  async showSnackBar(message: string) {
    this._snackBar.open(message, 'Chiudi', {
      direction: "ltr",
      duration: 2000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    });
  }

  async resetFilter(){
    this.manageSaleActivityFilterForm();
    this.filter();
  }

  async showSaleInfo(saleToken: string, deliveryInfo: any) {
    try {
      let saleDelivery: any;
      // let ref = this.dialog.open(SaleInfoComponent, { width: '50vw', data: { saleDelivery } });
      // return;
      let deliveryInformation = JSON.parse(deliveryInfo);
      if(deliveryInformation?.shop){
        if(deliveryInformation?.shop?.toLowerCase() === 'shopifysale'){
          saleDelivery = await this.shopifySaleService.findSaleDelivery(saleToken);
        }
        if(deliveryInformation?.shop?.toLowerCase() === 'cakesales'){
          saleDelivery = await this.cakeSaleService.findSaleDelivery(saleToken);
        }
        if(deliveryInformation?.shop?.toLowerCase() === 'flowerssales'){
          saleDelivery = await this.flowersSaleService.findSaleDelivery(saleToken);
        }
        if(deliveryInformation?.shop?.toLowerCase() === 'businesssales'){
          saleDelivery = await this.businessSaleService.findSaleDelivery(saleToken);
        }
        if (deliveryInformation?.shop?.toLowerCase() === 'deluxyexperiencesales') {
          saleDelivery = await this.deluxyExperienceSalesService.findSaleDelivery(saleToken);
        }
        if (deliveryInformation?.shop?.toLowerCase() === 'deluxydotcomsales') {
          saleDelivery = await this.deluxyDotComSalesService.findSaleDelivery(saleToken);
        }
      }

      if(saleDelivery){
        let ref = this.dialog.open(SaleInfoComponent, { width: '50vw', data: { saleDelivery } });
      } else {
        this.showSnackBar("Sale not found or may be get expired.");  
      }
    } catch (error) {
      this.showSnackBar("Sale not found or may be get expired.");
      console.log(error);
    }
  }

  navigate(event) {
    this.loadPartnerSaleActivities(event.limit, event.page, this.order);
  }

  public orderIcon(attribute: string | string[]): string {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    if(this.order){
      for (let attr of attribute) {
        switch (this.order[attr]) {
          case 'ASC':
            return 'fa-sort-up';
          case 'DESC':
            return 'fa-sort-down';
          default:
            return 'fa-sort';
        }
      }
    }
  }

  public navigateOrder(attribute: string | string[]) {
    if(this.order){
      delete this.order['Delivery.updatedAt'];
    }
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    if(this.order){
      for (let attr of attribute) {
        switch (this.order[attr]) {
          case 'ASC':
            this.order[attr] = 'DESC';
            break;
          case 'DESC':
            this.order[attr] = undefined;
            break;
          default:
            this.order = {}
            this.order[attr] = 'ASC';
            break;
        }
      }
    }

    this.navigatePage(this.limit, this.page, { order: this.order });
  }

  navigatePage(limit: number, page: number, args: {} = {}) {
    args = this.escapeQueryStringParams(args);
    const previousArgs = Object.keys(args).length ? {} : this.route.snapshot.queryParams;
    const newParams = { ...previousArgs };
    newParams[`limit`] = limit;
    newParams[`page`] = page;
    this.router.navigate(this.route.snapshot.url.map(u => u.path), { queryParams: { ...newParams, ...args } }).then(data => {
      this.loadPartnerSaleActivities();
    });
  }

  private escapeQueryStringParams(args: {} = {}): {} {
    Object.keys(args).forEach(key => {
      switch (Object.prototype.toString.call(args[key])) {
        case '[object Number]':
        case '[object String]':
          // Keep the same
          break;
        case '[object Array]':
        case '[object Object]':
          // Convert to JSON
          args[key] = JSON.stringify(args[key]);
          break;
        default:
          // Not supported type
          delete args[key];
          break;
      }
    });
    return args;
  }

  handleAddressModal() {
    this.showAddressModal = !this.showAddressModal;
  }

  async confirmPickupAddress() {

    if (!this.selectedPickupAddress || !this.pendingSaleAction) {
      this.showSnackBar(`Seleziona un indirizzo di ritiro prima di confermare.`);
      return;
    }

    this.isConfirming = true;

    try {
      const geoCodedAddress = await this.mapHelperService.geoCodeAddress(this.selectedPickupAddress);

      if (!geoCodedAddress || !geoCodedAddress.length) {
        this.showSnackBar(`Nessun indirizzo trovato su Google`);
        return;
      }

      const action = this.pendingSaleAction;

      if (action.type === 'unique' && action.deliveryId) {
        await this.manageSaleForUniqueProduct(action.deliveryId, 'accept');
      }

      if (action.type === 'nonUnique' && action.token && action.deliveryInformation) {
        action.deliveryInformation.pickUpAddress = this.selectedPickupAddress;
        await this.processNonUniqueAccept(action.token, action.deliveryInformation);
      }

      this.pendingSaleAction = null;
      this.selectedPickupAddress = null;
      this.showAddressModal = false;

    } catch (error) {
      this.showSnackBar(`Impossibile confermare l'indirizzo di ritiro. Per favore riprova.`);
    } finally {
      this.isConfirming = false;
    }

  }

}
